import styled from '@emotion/styled'

import Tabs, { useTabs } from '@segment/matcha/components/Tabs'
import { DataCollectIcon, DownloadCloudIcon, ChartIcon } from '@segment/matcha/components/Icons/Brandbook'

import CarouselCardBase, * as CarouselCard from '@segment/matcha/recipes/CarouselCard'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionTabbedBase, * as SectionTabbed from '@segment/matcha/recipes/SectionTabbed'

import CollectUserEventDataImage from './CollectUserEventDataImage'
import LeveragePreBuiltCloudSourcesImage from './LeveragePreBuiltCloudSourcesImage'
import SendTheDataImage from './SendTheDataImage'

const copy = {
  heading: `Collect and process your customer data at scale`,
  description: `Twilio Segment is a Customer Data Platform that enables you to use a single API to collect, standardize, and unify your customer data. Segment handles over 1 million events per second and is trusted by over 200,000 developers.`,
  tabs: [
    {
      key: `collect-user-event-data`,
      icon: <DataCollectIcon />,
      title: `Implement tracking on your website or mobile apps to collect clickstream data`,
      image: <CollectUserEventDataImage />,
    },
    {
      key: `leverage-pre-built-cloud-sources`,
      icon: <DownloadCloudIcon />,
      title: `Leverage pre-built cloud sources for Twilio and Sendgrid to collect campaign data`,
      image: <LeveragePreBuiltCloudSourcesImage />,
    },
    {
      key: `send-the-data`,
      icon: <ChartIcon />,
      title: `Send that data to a data warehouse for deeper analysis (and other tools on a paid Segment plan)`,
      image: <SendTheDataImage />,
    },
  ],
}

const CollectAndProcess = () => {
  const { activeTabKey, getTabsProps, getTabsMotionProps } = useTabs(copy.tabs[0].key)

  return (
    <SectionComponent variant="centered">
      <Section.Contents>
        <SectionTabbedBaseStyled>
          <SectionTabbed.Copy>
            <CopyTextBase>
              <CopyText.Heading tag="h2" variant="h2">
                {copy.heading}
              </CopyText.Heading>
              <CopyText.Description tag="p">{copy.description}</CopyText.Description>
            </CopyTextBase>

            <TabsWrapper>
              <Tabs {...getTabsProps()} mode="vertical" variant="filled">
                {copy.tabs.map((tab) => (
                  <CarouselCardBase value={tab.key} key={tab.key} active={activeTabKey === tab.key}>
                    <CarouselCardContainer alignment="left" headerPosition="top">
                      <CarouselCard.Header>{tab.icon}</CarouselCard.Header>
                      <CarouselCard.Body>
                        <CarouselCard.Title>{tab.title}</CarouselCard.Title>
                      </CarouselCard.Body>
                    </CarouselCardContainer>
                  </CarouselCardBase>
                ))}
              </Tabs>
            </TabsWrapper>
          </SectionTabbed.Copy>
          {copy.tabs.map((tab) => (
            <SectionTabbed.Media key={tab.key} {...getTabsMotionProps(tab.key)}>
              <SectionTabbed.Picture>{tab.image}</SectionTabbed.Picture>
            </SectionTabbed.Media>
          ))}
        </SectionTabbedBaseStyled>
      </Section.Contents>
    </SectionComponent>
  )
}

const SectionComponent = styled(SectionBase)`
  overflow: hidden;

  ${Section.Wrapper} {
    gap: 0;
  }
`

const SectionTabbedBaseStyled = styled(SectionTabbedBase)`
  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    gap: 140px;
  }
`

const CarouselCardContainer = styled(CarouselCard.Container)``

const TabsWrapper = styled.div`
  margin-top: 40px;
`

export default CollectAndProcess
